import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class DialogOverlayService {
  private overlayElement: HTMLElement | null = null;

  createOverlay(onOverlayClick?: () => void): HTMLElement {
    if (this.overlayElement) {
      return this.overlayElement;
    }

    this.overlayElement = document.createElement('div');
    this.overlayElement.className =
      'fixed inset-0 z-[70] flex items-center justify-center bg-black/50 p-4';
    this.overlayElement.setAttribute('role', 'dialog');
    this.overlayElement.setAttribute('aria-modal', 'true');
    this.overlayElement.tabIndex = 0;

    if (onOverlayClick) {
      this.overlayElement.addEventListener('click', (event) => {
        if (event.target === this.overlayElement) {
          onOverlayClick();
        }
      });
    }

    document.body.appendChild(this.overlayElement);
    return this.overlayElement;
  }

  removeOverlay(): void {
    if (this.overlayElement?.parentNode) {
      document.body.removeChild(this.overlayElement);
      this.overlayElement = null;
    }
  }
}
